/* eslint-disable max-len */
import { QueryTypes } from 'services/api/data'

import { ROUTE_PATHS } from 'router/routes'

import { slotsCasinoRoute } from 'shared/constants/routes/slotsRoutes'
import { languagesType, shortLanguages } from 'shared/locale'

import GameCatalogConverter from './providersData/GameCatalog/GameCatalogConverter'
import { getPureGameId } from './providersData/GameCatalog/uniqGameId'
import OutcomeConverter from './providersData/Outcome/OutcomeConverter'
import SoftwissConverter from './providersData/Softswiss/SoftwissConverter'
import UpgamingConverter from './providersData/Upgaming/UpgamingConverter'
import { ISlotProvidersConfiguration, Providers } from './types/configuration'
import { ISlotViewItem } from './types/interfaces/Slots/Slots'
import { renameProducerForKeltgamesStart } from './utils/helpers'

type ConvertorsTypes = OutcomeConverter | SoftwissConverter | UpgamingConverter | GameCatalogConverter

const OutcomeConverterClass = new OutcomeConverter()
const SoftwissConvterClass = new SoftwissConverter()
const UpgamingConverterClass = new UpgamingConverter()
const GameCatalogConverterClass = new GameCatalogConverter()

export const slotProvidersConfiguration: ISlotProvidersConfiguration<ConvertorsTypes> = {
  softwiss: {
    gameListUrl: 'api/integrations/softswiss/v2/games/',
    converter: SoftwissConvterClass,
    multiProvider: true,
    slotsCount: 2939,
    sessionUrlData: {
      url: 'api/integrations/softswiss/createsession/',
      demoUrl: 'api/integrations/softswiss/demostart/',
      method: QueryTypes.POST,
      getBody: params => ({
        game: params.gameId,
        return_url: `${location.origin}${slotsCasinoRoute}`,
        client_type: params.isDesktop ? 'desktop' : 'mobile',
      }),
      converter: SoftwissConvterClass.convertGameUrl,
    },
  },

  otc: {
    // authRequired: true,
    gameListUrl: 'api/integrations/outcome/v2/gamelist/',
    converter: OutcomeConverterClass,
    slotsCount: 878,
    sessionUrlData: {
      url: 'api/integrations/cf73bd58/login/',
      demoUrl: 'api/integrations/cf73bd58/login/demo/',
      freeSpinUrl: 'api/integrations/cf73bd58/login/freespin/',
      freeSpinInfoUrl: 'api/users/freespin-session/',
      method: QueryTypes.POST,
      getBody: params => ({
        GameId: params.gameId,
      }),
      converter: OutcomeConverterClass.convertGameUrl,
      freeSpinInfoConverter: OutcomeConverterClass.convertFreeSpinInfo,
      getHeaders: () => ({ 'Content-Type': 'application/json' }),
    },
    multiProvider: true,
  },

  '028142ca': {
    gameListUrl:
      // eslint-disable-next-line max-len
      'api/integrations/028142ca/games?producer=evosw,bgaming&page_size=2000',
    converter: GameCatalogConverterClass,
    slotsCount: 101,
    sessionUrlData: {
      url: 'api/integrations/028142ca/login',
      freeSpinUrl: 'api/integrations/028142ca/login/freespin',
      freeSpinInfoUrl: 'api/users/freespin-session/',
      method: QueryTypes.POST,
      getBody: params => ({
        is_mobile: +!params.isDesktop,
        system: params.gameList.find((t: ISlotViewItem) => t.gameId === params.gameId)?.additionalData?.system,
        page_code: getPureGameId(params.gameId),
      }),
      converter: GameCatalogConverterClass.convertGameUrl,
      freeSpinInfoConverter: OutcomeConverterClass.convertFreeSpinInfo,
    },
  },

  '08f21347': {
    gameListUrl:
      // eslint-disable-next-line max-len
      'api/integrations/08f21347/games?page_size=1000',
    converter: GameCatalogConverterClass,
    slotsCount: 101,
    sessionUrlData: {
      url: 'api/integrations/08f21347/login',
      method: QueryTypes.POST,
      getBody: params => ({
        symbol: getPureGameId(params.gameId),
        platform: params.isDesktop ? 'WEB' : 'MOBILE',
        play_mode: 'REAL',
        lobby_url: `${location.origin}${ROUTE_PATHS.SLOTS_CASINO}`,
      }),
      converter: GameCatalogConverterClass.convertGameUrlPragmatic,
    },
  },

  [Providers.digitain]: {
    gameListUrl: `api/integrations/81339664/games?page_size=20000`,
    converter: GameCatalogConverterClass,
    sessionUrlData: {
      url: '',
      getBody: () => ({}),
      converter: () => '',
    },
  },

  [Providers.KELTGAMES]: {
    gameListUrl: `api/integrations/20c90087/games?page_size=2000`,
    converter: GameCatalogConverterClass,
    sessionUrlData: {
      url: `api/integrations/${Providers.KELTGAMES}/session/`,
      freeSpinUrl: `api/integrations/${Providers.KELTGAMES}/session/freespin/`,
      freeSpinInfoUrl: 'api/users/freespin-session/',
      method: QueryTypes.POST,
      getBody: params => ({
        game_alias: params.gameSlug,
        is_mobile: !params.isDesktop,
        provider: renameProducerForKeltgamesStart[params.provider] || params.provider,
        language: params?.lang ? shortLanguages[params.lang as languagesType] : undefined,
      }),
      freeSpinInfoConverter: OutcomeConverterClass.convertFreeSpinInfo,
      converter: GameCatalogConverterClass.convertGameUrlKeltgames,
    },
  },

  // b480999a: {
  //   gameListUrl:
  //     // eslint-disable-next-line max-len
  //     'api/integrations/b480999a/games?page_size=1000',
  //   converter: GameCatalogConverterClass,
  //   sessionUrlData: {
  //     url: 'api/integrations/b480999a/login',
  //     method: QueryTypes.POST,
  //     getBody: params => ({
  //       game_id: getPureGameId(params.gameId),
  //     }),
  //     converter: GameCatalogConverterClass.convertGameUrlBcraft,
  //   },
  // },
}

export const liveGamesProviders: string[] = Object.values(slotProvidersConfiguration).reduce(
  (acc, t) => [...acc, ...(t.liveGamesProviders || [])],
  [] as string[],
)

// В default list не забывать задавать поле isDefault, щобы не дублировалось
